import React, { useState } from 'react';
import './AuthScreen.css';

interface AuthScreenProps {
  onLogin: (credentials: { username: string; password: string }) => Promise<boolean>;
  isLoading?: boolean;
}

const AuthScreen: React.FC<AuthScreenProps> = ({ onLogin, isLoading = false }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState<string[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = (): boolean => {
    const newErrors: string[] = [];
    
    if (!username.trim()) {
      newErrors.push('ユーザー名を入力してください');
    }
    
    if (!password) {
      newErrors.push('パスワードを入力してください');
    }
    
    setErrors(newErrors);
    return newErrors.length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    setErrors([]);

    try {
      const success = await onLogin({
        username: username.trim(),
        password
      });

      if (!success) {
        setErrors(['ユーザー名またはパスワードが正しくありません']);
      }
    } catch (error) {
      setErrors(['ログイン中にエラーが発生しました。しばらく後でお試しください。']);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-screen">
      <div className="auth-container">
        <div className="auth-header">
          <h1>介護スケジュール管理システム</h1>
          <p>スタッフ専用ログイン</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="username">ユーザー名</label>
            <input
              id="username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="ユーザー名を入力"
              disabled={isSubmitting || isLoading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">パスワード</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="パスワードを入力"
              disabled={isSubmitting || isLoading}
              autoComplete="current-password"
            />
          </div>

          {errors.length > 0 && (
            <div className="error-list">
              {errors.map((error, index) => (
                <div key={index} className="error">{error}</div>
              ))}
            </div>
          )}

          <button 
            type="submit" 
            className="login-btn"
            disabled={isSubmitting || isLoading}
          >
            {isSubmitting || isLoading ? 'ログイン中...' : 'ログイン'}
          </button>
        </form>

        <div className="auth-footer">
          <p>
            このシステムは池田介護研究所のスタッフ専用です。<br />
            ログインに問題がある場合は、システム管理者にお問い合わせください。
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthScreen;